(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["GB-Best-Sellers"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Tab switching functionality
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabPanels = document.querySelectorAll('.tab-panel');
  
  // Initialize Splide for each tab panel
  const initializeSplide = (tabPanel) => {
    const splide = new Splide(tabPanel.querySelector('.splide'), {
      perPage: 3,
      gap: '24px',
      arrows: true,
      pagination: true,
      autoplay: false,
      breakpoints: {
        768: {
          perPage: 2,
          arrows: true,
          pagination: true,
          autoplay: true,
          interval: 3000,
        },
        480: {
          perPage: 1,
          arrows: true,
          pagination: true,
          autoplay: true,
          interval: 3000,
        }
      }
    });
    
    splide.mount();
  };
  // Initialize Splide for the first (active) tab
  const activePanel = document.querySelector('.tab-panel:not(.hidden)');
  if (activePanel) {
    initializeSplide(activePanel);
  }
  
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      tabButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');
      
      tabPanels.forEach(panel => panel.classList.add('hidden'));
      const targetPanel = document.querySelector(`[data-tab-content="${button.dataset.tab}"]`);
      if (targetPanel) {
        targetPanel.classList.remove('hidden');
        initializeSplide(targetPanel); // Initialize Splide for the newly active tab
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
